import { GetterTree } from "vuex";
import { ActivityLogState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<ActivityLogState, RootState> = {

};
